<template>
	<section>
		<h1>Web Components</h1>

		<h2>Dashboard Filter Showcase</h2>
		<code>&lt;oewr-dashboard-showcase&gt;</code>

		<OewrDashboardShowcase />
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import OewrDashboardShowcase from '@/components/webcomponents/OewrDashboardShowcase.vue';

export default defineComponent({
	name: 'WebComponentsView',
	components: {
		OewrDashboardShowcase,
	},
});
</script>

<style lang="scss"></style>
